<form id="formClaveLogout" name="formClaveLogout" [action]="aClaveRequest.Url" target="_self" [method]="aClaveRequest.Metodo">
    <input type="hidden" name="country" [value]="aClaveRequest.Country" />
    <input type="hidden" [name]="aClaveRequest.RelayStateField" [value]="aClaveRequest.RelayState" />
    <input type="hidden" [name]="aClaveRequest.SamlRequestField" [value]="aClaveRequest.Request" />
</form>